import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [
  ["whatsapp", "Número de WhatsApp (con código de país, solo números)", "5493794000000"],
  ["phone", "Teléfono", ""],
  ["email", "Email", ""],
  ["address", "Dirección / ubicación", ""],
];

export const AdminSettings = () => {
  const { settings, setSettings } = useApp();
  const [f, setF] = useState(settings);
  const [busy, setBusy] = useState(false);
  useEffect(() => setF(settings), [settings]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/settings", f);
      setSettings(data);
      toast.success("Datos de contacto guardados");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="card-fv p-6 sm:p-8 max-w-2xl space-y-5" data-testid="admin-settings">
      {FIELDS.map(([k, label, ph]) => (
        <div key={k} className="space-y-2">
          <Label htmlFor={`s-${k}`}>{label}</Label>
          <Input id={`s-${k}`} required value={f[k] || ""} placeholder={ph} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`admin-settings-${k}-input`} />
        </div>
      ))}
      <button disabled={busy} className="btn-fv btn-red disabled:opacity-60" data-testid="admin-settings-save-button"><Save size={16} />{busy ? "Guardando…" : "Guardar"}</button>
    </form>
  );
};
